export default __webpack_public_path__ + "static/media/cd-icon-select.336534d6.svg";